var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccept(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7631 0.247129C16.079 0.576634 16.079 1.11087 15.7631 1.44037L5.87541 11.7529C5.7237 11.9111 5.51793 12 5.30337 12C5.08881 12 4.88304 11.9111 4.73133 11.7529L0.236947 7.06537C-0.0789824 6.73587 -0.0789824 6.20163 0.236947 5.87213C0.552877 5.54262 1.0651 5.54262 1.38103 5.87213L5.30337 9.96301L14.619 0.247129C14.9349 -0.0823762 15.4471 -0.0823762 15.7631 0.247129Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccept);
export default __webpack_public_path__ + "static/media/accept.ded8e0b3f12e2712b94789709b39c3c0.svg";
export { ForwardRef as ReactComponent };